import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import Loader from '../../components/loader';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function App() {

    const [orderData, setorderData] = useState([]);
    const userId = sessionStorage.getItem("TRCUserId");
    const [date, setDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dealer, setDelaer] = useState('');
    const [loading, setLoading] = useState(false);

    const filteredOrders = orderData?.filter(order => {
        const dealerMatches = !dealer || 
            (order.dealerData?.dealer?.toLowerCase().includes(dealer.toLowerCase()));
        
        return dealerMatches
    });

    console.log(orderData);

    const formatDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const apidates = (date) => {
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const changeDate = async () =>{
        
        setLoading(true);  
        
        const sendData = {
            start: apidates(date),
            end: apidates(endDate)
        }; 

        try {
            const response = await axios.post('https://api.trucoo.in/chellan/chellan/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            console.log(response.data);
            if(response.data.status === 'success'){
                //const filterData = response.data.data.filter(datas => datas.status === 'Placed');
                setorderData(response.data.data);
                setDate(response.data.sdate);
                setEndDate(response.data.edate);
            }else{
                setorderData([]);
                setDate(response.data.sdate);
                setEndDate(response.data.edate);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoading(false);  
    };

    const getOrders = async () => {
        setLoading(true);  
        try {
            const response = await axios.post('https://api.trucoo.in/chellan/chellan/', {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setorderData(response.data.data);
                setDate(response.data.sdate);
                setEndDate(response.data.edate);
            }else{
                setorderData([]);
                setDate(response.data.sdate);
                setEndDate(response.data.edate);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoading(false);  
    };

    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };


    useEffect(() => {
        getOrders();
    },[]);

    useEffect(() => {
        changeDate();
    },[date, endDate]);

    let cratesTotal = 0;
    let qtyTotal = 0;
    let weightTotal = 0;
    let orderTotal = 0;

return(
<>
    {loading && <Loader />}
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
            <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Delivery Challan</h4>
                  <p class="mb-0 box-subtitle">DC Details {date} to {endDate}</p>
                  
                  <div className='input-group' style={{width: '550px', float: 'right', marginTop: '-20px'}}>
                    <input type='text' class="form-control" placeholder='Enter Dealer Name...' value={dealer} onChange={(e)=> setDelaer(e.target.value)} />
                    <input type="date" class="form-control" value={formatDate(date)} onChange={(e)=>setDate(e.target.value)} style={{maxWidth: '130px'}} />
                    <input type="date" class="form-control" value={formatDate(endDate)} onChange={(e)=>setEndDate(e.target.value)} style={{maxWidth: '130px'}} />
                  </div>
                </div>
                <div class="box-body">
                    <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 270px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                        <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                        <thead>
                            <tr class="text-dark">
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Challan ID</th>
                                <th>Dealer</th>
                                <th>Crates</th>
                                <th>Qty</th>
                                <th>L/KG</th>
                                <th>Order Total</th>
                                <th>View More</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOrders.length > 0 ? 
                            <>
                            
                            {filteredOrders.map((order, index) => {
             
                                const crates = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0);
                                const qty = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item.itemGrade), 0);
                                const weight = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.itemGrade * (item?.itemWeight/1000)), 0);
                                const total = Number(order.totalPayment) - Number(order.discount);
                                
                                cratesTotal += crates;
                                qtyTotal += qty;
                                weightTotal += weight;
                                orderTotal += total;

                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{formatViewDate(order.date)}</td>
                                        <td>DC/{order?.invoiceId}/{getFiscalYearLabel(new Date(order?.date))}</td>
                                        <td>{order.dealerData.dealer}</td>
                                        <td className='text-end'>{Number(crates).toFixed(2)}</td>
                                        <td className='text-end'>{Number(qty).toFixed(2)}</td>
                                        <td className='text-end'>{Number(weight).toFixed(2)}</td>
                                        <td className='text-end'>{Number(total).toFixed(2)}</td>
                                        
                                        <td>
                                            <a href={`/chellan-details?id=${order.orderId}`} class="form-control" style={{textAlign: 'center'}}>View</a>
                                        </td>
                                        
                                    </tr>
                                )}

                            )}
                                <tr>
                                    <th colSpan={4}>Total</th>
                                    <th className='text-end'>{Number(cratesTotal).toFixed(2)}</th>
                                    <th className='text-end'>{Number(qtyTotal).toFixed(2)}</th>
                                    <th className='text-end'>{Number(weightTotal).toFixed(2)}</th>
                                    <th className='text-end'>{Number(orderTotal).toFixed(2)}</th>
                                    <th></th>
                                </tr>
                            </>
                            :(
                                <tr>
                                    <td class='text-center p-4' colSpan={8}>No Orders</td>
                                </tr>
                            )}
                            
                        </tbody>	
                    </table>
    
                    </div>              
                </div>
              </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;